import { createReducer, on } from '@ngrx/store';
import * as ProductActions from './biz-shop-banner.action';
import { BizShopBanner } from '../../models/biz-shop-banner';

export interface ErrorPayload {
  message: string;
  statusCode: number;
}

export interface BizShopBannerState {
  bizShopBanner: BizShopBanner[];
  loading: boolean;
  error: ErrorPayload | null;
}

export const initialState: BizShopBannerState = {
  bizShopBanner: [],
  loading: false,
  error: null,
};

export const bizShopBannerReducer = createReducer(
  initialState,

  // When loading biz Banner
  on(ProductActions.loadBizShopBanner, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // On successful Banner load
  on(ProductActions.loadBizShopBannerSuccess, (state, { bizShopBanner }) => ({
    ...state,
    bizShopBanner,
    loading: false,
  })),

  // On failed Banner load
  on(ProductActions.loadBizShopBannerFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

   // Clear products
   on(ProductActions.clearBizShopBanner, (state) => ({
    ...state,
    bizShopBanner: [],
    error: null,
  })),

);
